import apiBase from './base'
import apiMyBase from './myBase'

export const signIn = async (signInData: SignInRequest): Promise<SignInResponse> => {
  return await apiBase.doPostOld('/api/customers/sessions/sign_in', signInData)
}

export const signInWithAuthenticator = async (
  data: SignInAuthenticatorRequest
): Promise<SignInAuthenticatorResponse> => {
  return await apiBase.doPostOld('/api/customers/authenticator/verify', data)
}

export const signUp = async (signData: SignUpRequest): Promise<SignUpResponse> => {
  return await apiBase.doPostOld('/api/customers/register', signData)
}

export const signOut = async (): Promise<SignOutResponse> => {
  return await apiMyBase.doDeleteOld('/api/customers/sign_out')
}

export const sendMagicLink = async (
  tempId: string,
  code: string
): Promise<SendMagicLinkResponse> => {
  return await apiBase.doPostOld('/api/customers/sessions/magic_link', {
    temp: tempId,
    code
  })
}

export const verifyMagicLink = async (
  token: string,
  code: string,
  tempId: string
): Promise<VerifyMagicLinkResponse> => {
  return await apiBase.doPostOld('/api/customers/sessions/magic_link/verify', {
    token,
    code,
    temp: tempId
  })
}

export const getPasskeyChallenge = async (): Promise<PasskeyChallengeResponse> => {
  return await apiBase.doGetOld('/api/customers/sessions/passkey/challenge')
}

export const verifyPasskey = async (data: SignInPasskeyRequest): Promise<SignInPasskeyResponse> => {
  return await apiBase.doPostOld('/api/customers/sessions/passkey/verify', data)
}

export const ping = async (): Promise<PingResponse> => {
  return await apiBase.doGetOld('/api/customers/sessions/ping')
}

export default {
  signIn,
  signUp,
  signOut,
  ping,
  sendMagicLink,
  verifyMagicLink,
  getPasskeyChallenge,
  verifyPasskey,
  signInWithAuthenticator
}
